import { render } from "./EmployeeArchive.vue?vue&type=template&id=3d5fa332&scoped=true"
import script from "./EmployeeArchive.vue?vue&type=script&lang=js"
export * from "./EmployeeArchive.vue?vue&type=script&lang=js"

import "./EmployeeArchive.vue?vue&type=style&index=0&id=3d5fa332&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5fa332"]])

export default __exports__